import { render, staticRenderFns } from "./EditParticipantsDetails.vue?vue&type=template&id=f5e443fc&scoped=true"
import script from "./EditParticipantsDetails.vue?vue&type=script&lang=js"
export * from "./EditParticipantsDetails.vue?vue&type=script&lang=js"
import style0 from "./EditParticipantsDetails.vue?vue&type=style&index=0&id=f5e443fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e443fc",
  null
  
)

export default component.exports